<div class="h-100 d-flex flex-column">
	<app-title></app-title>

	<div class="flex-grow-1 calendar-container" style="overflow: hidden">
		<mat-calendar [(selected)]="selectedDate" [minDate]="minDate" [maxDate]="maxDate" [headerComponent]="exampleHeader"></mat-calendar>
	</div>

	<div class="row mt-3">
		<div class="col">
			<app-btn [dataTxt]="'BACK'" (callback)="onClickRetour()" [icon]="'chevron-left'" [iconLocation]="'left'"></app-btn>
		</div>
		<div class="col text-right">
			<app-btn [dataTxt]="'NEXT'" [classes]="'btnAnimation'" (callback)="onClickOk()" [icon]="'chevron-right'" [iconLocation]="'right'" [disabled]="!dateValid()"></app-btn>
		</div>
	</div>
</div>
